"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
// our root app component
var common_1 = require("@angular/common");
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var material_1 = require("@angular/material");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_dynamic_forms_controls_1 = require("@synisys/idm-dynamic-forms-controls");
var idm_dynamic_forms_ui_1 = require("@synisys/idm-dynamic-forms-ui");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var idm_reporting_controls_1 = require("@synisys/idm-reporting-controls");
var idm_tabular_report_builder_1 = require("@synisys/idm-tabular-report-builder");
var ng2_dragula_1 = require("ng2-dragula");
var index_1 = require("./components/index");
var material_module_1 = require("./material.module");
var page_builder_routes_1 = require("./page-builder.routes");
var settings_1 = require("./settings");
var shared_1 = require("./shared");
var idm_frontend_shared_1 = require("@synisys/idm-frontend-shared");
var export_page_popup_1 = require("./components/designer/page/export-page-popup");
var idm_export_zip_service_client_js_1 = require("@synisys/idm-export-zip-service-client-js");
var PageBuilderModule = /** @class */ (function () {
    function PageBuilderModule() {
    }
    PageBuilderModule = __decorate([
        core_1.NgModule({
            declarations: [
                index_1.PageDesignerComponent,
                index_1.DesignerWidgetsComponent,
                index_1.PageViewComponent,
                export_page_popup_1.ExportPagePopupComponent,
            ],
            exports: [
                index_1.PageDesignerComponent,
                index_1.DesignerWidgetsComponent,
                index_1.PageViewComponent,
            ],
            entryComponents: [export_page_popup_1.ExportPagePopupComponent],
            imports: [
                forms_1.FormsModule,
                idm_dynamic_forms_ui_1.DynamicPageModule,
                idm_ng_controls_1.ControlsModule,
                ng2_dragula_1.DragulaModule,
                settings_1.DesignerSettingsModule,
                common_1.CommonModule,
                idm_de_service_client_js_1.DeControlsModule,
                idm_dynamic_forms_controls_1.DynamicFormControlsModule,
                page_builder_routes_1.pageBuilderRouting,
                material_module_1.MaterialModule,
                material_1.MatDialogModule,
                idm_reporting_controls_1.ReportingViewsModule,
                idm_reporting_controls_1.ReportingControlsModule,
                idm_tabular_report_builder_1.ReportingModule,
                idm_frontend_shared_1.SisUtilitiesModule,
                idm_frontend_shared_1.SisTranslateModule,
            ],
            providers: [
                shared_1.PageRuntimeComponentLoaderService,
                {
                    provide: idm_export_zip_service_client_js_1.ExportZipService,
                    useClass: idm_export_zip_service_client_js_1.HttpExportZipService,
                },
            ],
        })
    ], PageBuilderModule);
    return PageBuilderModule;
}());
exports.PageBuilderModule = PageBuilderModule;
//# sourceMappingURL=page-builder.module.js.map